import { AlertService, CommonService, UserService } from 'src/app/services';
import { Component, OnInit, Input, OnChanges, ChangeDetectorRef } from "@angular/core";
import { EPatient, SystemData, EPrescriber, PatientInfo } from "../../../models";
import * as moment from "moment";
import * as _ from "lodash";
import { PatientStore } from 'src/app/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs'; 
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MsgConfig } from 'src/app/app.messages';
import { CommunicationInfoPopUpComponent } from '../communication-info-pop-up/communication-info-pop-up.component';

@Component({
    selector: "app-rx-patient-card",
    templateUrl: "./rx-patient-card.component.html"
})
export class RxPatientCardComponent implements OnInit, OnChanges {
    refreshInsuId: any;
    systemData: SystemData;
    rxPatientModel: EPatient;
    age: any;
    primaryInsu: any;
    mobile: any;
    telephone: any;
    contactType: any[] = [];
    hasPatientHistory: boolean;
    Is340BStatus:boolean;
    PatientInfo: PatientInfo;
    drugInfo: any;
    isFromErx: any;
    unsubscribe$: Subject<void> = new Subject();
    @Input() rxFG: any;

    isIvrEnabled = environment.isIvrEnabled;
    primaryInsuFromErxtoRequest: any;
    EditPatientDetails: any;
    isOnChanges = false;
    patientEditData: any;
    primaryInsuFromErxtoRequestForCash: any;
    showComms: boolean;
    updatecommsinfo: any;
    @Input()
    set primaryInsuFromErxtoRequestObejct(pi: any) {
        if (pi) {
            this.primaryInsuFromErxtoRequest = pi;
        } else {
            this.primaryInsuFromErxtoRequest = {};
        }
    }
    @Input()
    set primaryInsuFromErxtoRequestForCashObejct(cashInfo: any) {
        if (cashInfo) {
            this.primaryInsuFromErxtoRequestForCash = cashInfo;
        } else {
            this.primaryInsuFromErxtoRequestForCash = {}
        }
    }
    @Input()
    set RxPatientInfo(pi: EPatient) {
        if (pi) {
            this.rxPatientModel = pi;
            this.setPackagingPatient();
            if (pi && pi.dob) {
                const dob = moment(pi.dob);
                const years = moment().diff(dob, "year");
                dob.add(years, "years");
                const months = moment().diff(dob, "months");
                dob.add(months, "months");
                this.age = years + " Yrs, " + months + " M";
            } else {
                this.age = null;
            }
            this.primaryInsu = _.filter(this.rxPatientModel.insurance, {
                insuranceid: +this.rxPatientModel.insuranceid
            })[0];
            if (!this.primaryInsu) {
                this.primaryInsu = _.filter(this.rxPatientModel.insurance, {
                    IsCash: true
                })[0];
            }
            if (!this.primaryInsu) {
                this.primaryInsu = _.filter(this.rxPatientModel.insurance, {
                    insurerid: this.systemData["DefaultValuese"][0]["CashInsurerId"]
                })[0];
            }
            if (!this.primaryInsu) {
                this.primaryInsu = _.filter(this.rxPatientModel.insurance, {
                    insuranceid: 10189
                })[0];
            }
        }
    }

    @Input()
    set HasPatientHistoryVisb(ph: boolean) {
        this.hasPatientHistory = ph;
    }

    @Input()
    set DrungInfo(di: boolean) {
        this.drugInfo = di;
    }

    @Input() IsFromErxRequest: any;

    @Input()
    set EditPatientInfo(data: any) {
        if (data) {
            this.updateContactType(data);
        }
    }

    @Input()
    set RefreshInsuId(InsuRef: any) {
        this.refreshInsuId = InsuRef;
        this.refreshInsuranceId();
    }

    @Input()
    set IsFromERx(ifr: any) {
        this.isFromErx = ifr;
    }

    @Input() prescriber: EPrescriber;

    constructor(private _commonServ: CommonService, private _patientStore: PatientStore, private _cdr: ChangeDetectorRef, private _comnUtil: CommonUtil,
        private _modalServ: NgbModal, private _userServ: UserService, private _router: Router, private _alerSer: AlertService,
    ) {
        this._commonServ.systemData$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
                if (resp) {
                    this.systemData = resp;
                }
            });
        this._patientStore.patientEditInfo$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
                this.patientEditData = resp;
            });
    }

    ngOnInit() {
        this.isIvrEnabled = environment.isIvrEnabled && localStorage.getItem("IvrGUIDDetails") ? true : false;
        if ((!this.PatientInfo || this.IsFromErxRequest) && !this.isOnChanges) {
            this.getEditPatDetails();
            this.isOnChanges = true;
        }
        if (this.rxFG && this._router.url === "/eprx/rx?fm=nr" && this.rxFG.getRawValue()?.rxType==="nr") this.showComms = true;
        this._commonServ._miniMizeScreen$.subscribe(val => {
                if(val && val.miniScreen && this.updatecommsinfo) {
                        this.updatecommsinfo.close();
                }
            });
    }
    setPackagingPatient() {
        // To display the Packaging Patient
        if(this.systemData['Interfaces']?.length) {
            let packagingPatient = this.systemData['Interfaces'] && this.systemData['Interfaces'].length && this.systemData['Interfaces'].find((item: any) => {return (item['Id'] === this.rxPatientModel['InterfaceId']) } );
            this.rxPatientModel['packagingPatient'] = null;
            this._cdr.detectChanges();
            this.rxPatientModel['packagingPatient'] = packagingPatient ?   packagingPatient['Name'] : "";
        }
        const settings = this._commonServ.getSetttingValue("ThreeFourtyBSettings", "340B_PHARM") === "1";
        this.Is340BStatus = (this.rxPatientModel?.Is340B && settings)? true : false;
    }
    async getEditPatDetails() {
        if (this.rxPatientModel && this.rxPatientModel["patientid"]) {
            // const data = await this._commonServ.getEditPatientInformation(this.rxPatientModel["patientid"]).toPromise();
            this.updateContactType(this.patientEditData);
        }
    }

    refreshInsuranceId() {
        if (this.refreshInsuId) {
            this.primaryInsu = _.filter(this.rxPatientModel.insurance, {
                insuranceid: +this.refreshInsuId
            })[0];
        }
    }
    updateContactType(data) {
        this.contactType = [];
        this.mobile = null;
        this.telephone = null;
        this.PatientInfo = data;
        if (this.PatientInfo && this.PatientInfo["PerPrefContact"] && this.PatientInfo["PerPrefContact"].length) {
            this.PatientInfo["PerPrefContact"].map(val => {
                if (val.IsPreferred) {
                    this.mobile = val.ContactNumber;
                } else {
                    this.contactType.push(val);
                }
            });
        }
        if (this.contactType && this.contactType.length) {
            this.contactType.map(val => {
                if (val.ContactType === "Mobile" && val.ContactNumber) {
                    this.telephone = val.ContactNumber;
                    return;
                } else if (val.ContactType === "Telephone") {
                    this.telephone = val.ContactNumber;
                }
            });
        }
    }

    ngOnChanges(changes?: any) {
        if ((!this.PatientInfo || this.IsFromErxRequest) && !this.isOnChanges) {
            this.isOnChanges = true;
            this.getEditPatDetails();
        }
        if (changes && changes.primaryInsuFromErxtoRequestObejct && changes.primaryInsuFromErxtoRequestObejct.currentValue) {
            /*   this.primaryInsuFromErxtoRequest  = {};
               setTimeout(() => {
                   this.primaryInsuFromErxtoRequest  = changes.primaryInsuFromErxtoRequestObejct.currentValue;
               }, 100);*/
        }
    }

    async clickToCallOutBond(mobile) {
        let resp;
        let callRequest = this._comnUtil.clickToOutBondcall(mobile);
        if(callRequest && mobile && this.isIvrEnabled) {            
            if(callRequest?.ivrVendor === 1) {
                resp = await this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                if(resp) this._comnUtil.openCallLogPopup(mobile,this.rxPatientModel,'Patient');
                else { this._alerSer.error(MsgConfig.IVR_Call_Error); this._commonServ._isCallOngoing$.next(null); }
            } else if(callRequest?.ivrVendor === 2) {
                this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                this._comnUtil.openCallLogPopup(mobile,this.rxPatientModel,'Patient');
            }
        } 
    }  

    openCommsPopUp() {
        let checkIsCallOngoing = this._commonServ._isCallOngoing$.getValue();
        let checkCallLogData = this._commonServ._storeCallLogDetails$.getValue();
        if(checkCallLogData && checkIsCallOngoing) {
            this._commonServ._miniMizeScreen$.next({ details: checkCallLogData, miniScreen: false });
            this.updatecommsinfo = this._modalServ.open(CommunicationInfoPopUpComponent, { size: "md", backdrop: false, keyboard: true,
            windowClass: "medium-modal-50", centered: true });
            this.updatecommsinfo.componentInstance.UpdateCallLogDetails = checkCallLogData;
            this.updatecommsinfo.componentInstance.IsMaxScreen = true;
            this.updatecommsinfo.componentInstance.IsfromManual = false;
            this.updatecommsinfo.componentInstance.IsOutbondCall = checkCallLogData?.logDetails?.callDetails?.direction === 'Outbound' ? true : false;
            this.updatecommsinfo.componentInstance.CallLogDetails = this._commonServ.getIvrGUIDDetails(this._commonServ.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
            this.updatecommsinfo.componentInstance.IsFrom = checkCallLogData?.logDetails?.recipient?.entityType === 1 ? 'Patient' : checkCallLogData?.logDetails?.recipient?.entityType === 2 ? 'Prescriber' : checkCallLogData?.logDetails?.recipient?.entityType === 3 ? 'Insurance' : 'Pharmacy';
            this.updatecommsinfo.componentInstance.PatientDetails = checkCallLogData?.logDetails?.patient;
            this.updatecommsinfo.componentInstance.PhoneNumber = checkCallLogData?.logDetails?.callDetails?.phoneNumber;
            this.updatecommsinfo.componentInstance.IsPopUpClosed.subscribe((resp) => {
            if (this.updatecommsinfo) {
                this.updatecommsinfo.close();
            }
            });
        } else {
        this._comnUtil.openCallLogPopup((this.rxPatientModel?.mobile || this.rxPatientModel?.telephone),this.rxPatientModel,'Patient',true,true);
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
